var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "upload-button",
      class: { blue: _vm.blue },
      on: { click: _vm.buttonClick },
    },
    [
      _c(
        "svg",
        {
          staticClass: "upload-button-icon",
          attrs: {
            width: "18",
            height: "22",
            viewBox: "0 0 18 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M1 11V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V11",
              stroke: "black",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M13 5L9 1L5 5",
              stroke: "black",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M9 1V14",
              stroke: "black",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
        ]
      ),
      _vm._v("\n  Upload\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }